import React from "react";
import _ from "lodash";
import Table from "../dashboard/table";
import Area from "../dashboard/areaDatetime";
import Dial from "../dashboard/dial";
// import Bar from "../dashboard/bar";
import Heading from "../dashboard/heading";

const OpSum = ({ user, data }) => {
  const throughputTable = [
    "COS-TN-V-0D",
    "WSW-TN-V-0D",
    "SXB-TN-V-0D",
    "TJTSS-TN-V-0D",
    "TJTR-TN-V-0D",
    "SYTSP-TN-V-0D",
    "TJTS-TWE-V-0D",
    "SYTSP-TWE-V-0D",
    "OUT-TWE-V-0D",
    "AFT-TN-V-0D",
  ];
  const energyTable = ["ERG-STWE-V-0D", "DE-GJWEVAP-PC-0D"];
  const otherTable = ["COS-POL-M-0D", "WR-TN-ENT-1D"];
  const environmentTable = ["TWT-M3-V-0D", "WW-TN-V-0D"];
  const extractionTable = ["NRG-DRAFT-V-0D", "CAO-PCB-V-0D"];
  const extractionTable2 = [
    "DRL-TPOL-V-0D",
    "DIFF-LOSS-PBS-0D",
    "LX-LOSS-PBS-0D",
  ];
  const sugarTable = [
    "WS-COL-V-0D",
    "WS-LOD-M-0D",
    "WS-INS-M-0D",
    "WS-SO2-M-0D",
  ];
  const sugarTable2 = [
    "WS-TUR-M-0D",
    "WS-ASH-V-0D",
    "WS-MA-M-0D",
    "WS-CVAR-V-0D",
    "WS-TMP-M-0D",
  ];
  const feedTable = ["AF-DS-M-0D", "AF-TSM-M-0D", "AF-FN-M-0D", "PP-DS-M-0D"];
  const feedTable2 = ["AF-AIA-M-0D", "AF-AIA-RAVG-7D", "RAFA-ADDN-PC-0D"];

  if (_.isEmpty(data)) return <h5>No Data</h5>;
  return (
    <React.Fragment>
      <div className="row">
        <div className="col">
          {!_.isEmpty(data) && <Heading data={data} parameter="DY-NO-V-0T" />}
        </div>
        {/* <div className="col text-right">
          <p className="lead">Approved By: {user && user.FULL_NAME}</p>
        </div> */}
      </div>
      <div className="row">
        <div className="col">
          <Area
            parameter="COS-TN-V-0D"
            data={data}
            group="row-1"
            targetParameter="COS-TN-TGT-1D"
            targetLabel="DCS Target"
          />
        </div>
        <div className="col">
          <Area
            parameter="WSW-TN-V-0D"
            data={data}
            group="row-1"
            targetParameter="WSW-TN-TGT-1D"
            targetLabel="DCS Target"
          />
        </div>
        <div className="col">
          <Area
            parameter="ERG-STWE-V-0D"
            data={data}
            group="row-1"
            targetValue={1.2}
          />
        </div>
        <div className="col">
          <Area parameter="ERG-KWH-PWE-0D" data={data} group="row-1" />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Table
            title={"Throughput"}
            parameterList={throughputTable}
            data={data}
          />
        </div>
        <div className="col">
          <Table title="Energy" parameterList={energyTable} data={data} />
          <Table title="Other" parameterList={otherTable} data={data} />
          <Table
            title="Environment"
            parameterList={environmentTable}
            data={data}
          />
        </div>
      </div>
      <hr className="bg-success" />
      <div className="row">
        <div className="col">
          <Table
            title="Extraction"
            parameterList={extractionTable}
            data={data}
          />
        </div>
        <div className="col">
          <Table parameterList={extractionTable2} data={data} />
        </div>
      </div>
      <hr className="bg-success" />
      <div className="row">
        <div className="col">
          <Table title="Sugar Quality" parameterList={sugarTable} data={data} />
        </div>
        <div className="col">
          <Table parameterList={sugarTable2} data={data} />
        </div>
      </div>
      <hr className="bg-success" />
      <div className="row">
        <div className="col">
          <Table
            title="Animal Feed Quality"
            parameterList={feedTable}
            data={data}
          />
        </div>
        <div className="col">
          <Table parameterList={feedTable2} data={data} />
        </div>
      </div>
      {/* {user && user.SITE === "WI" && (
        <div className="row">
          <div className="col">
            <Bar
              stack1Label={"Space"}
              stack1List={["TJT-SPC-TN-1D", "TJT-SPC-TN-7D"]}
              stack2Label={"Stock"}
              stack2List={["TJT-TN-ST-1D", "TJT-TN-ST-7D"]}
              data={data}
            />
          </div>
        </div>
      )} */}
      <div className="row">
        <div className="col">
          <Dial parameter={"WS-QUAL-KPI-0D"} data={data} />
        </div>
        <div className="col">
          <Dial parameter={"AF-QUAL-KPI-0D"} data={data} />
        </div>
        <div className="col">
          <Dial parameter={"TJTS-KPIQ-V-0D"} data={data} />
        </div>
        <div className="col">
          <Dial parameter={"SYTS-KPIQ-V-0D"} data={data} />
        </div>
        <div className="col">
          <Dial parameter={"LX70-KPIQ-V-0D"} data={data} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default OpSum;
